import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import { Get, Post } from 'Xhr/Xhr';

export const SavePatient = async (
  data,
  setShowForm,
  setShowSearchBox,
  selectedPatient
) => {
  data.idCityTavalod =
    selectedPatient?.idCityTavalod || data?.idCityTavalod;
  data.idCitySokonat =
    selectedPatient?.idCityTavalod || data?.idCityTavalod;

  return Post(
    'POST',
    `${process.env.REACT_APP_API_URL_API_SAVE_PATIENT}`,
    true,
    {
      ...data,
    }
  ).then((response) => {
    // console.log('responseresponse--->', response);
    if (response.data.resCode === 1) {
      SwalAlert('success', response.data.resMessage, false);
    } else {
      SwalAlert('error', response.data.resMessage, false);
    }

    setShowForm();
    setShowSearchBox(true);
  });
};
